<template>
  <div>
    <vx-card>        
      <h3 class="gw-det-title">Observaciones del equipo de operaciones</h3>
      <p class="gw-det-sub">
        Lo que nuestro equipo encontró en cada verificación. Cada pestaña es un
        equipo distinto.
      </p>
      <vs-progress indeterminate color="primary" v-if="progressReport"></vs-progress> 
      <!-- Si no queda ninguna pestana visible se dice, en vez de dejar una
           tarjeta vacia. Ademas vs-tabs sin hijos tira un error en cada
           carga: indexa $children con -1. -->
      <p v-if="!hayPestanas" class="gw-det-vacio">
        Todavía no hay observaciones del equipo para este proceso.
      </p>

      <template v-if="hayPestanas">       
        <vs-tabs>          
          <div v-for="(observations, index_observation) in project.observations" :key="index_observation">
            <vs-tab v-bind:label="`Equipo ${observations[0].type}`" v-if="showObservations(observations[0].type)">
              <!-- Antes esto era una tabla de dos columnas en la que la
                   fecha partia en tres lineas y el texto se iba a lo ancho de
                   la pantalla. Se lee mejor con la fecha encima, pequena. -->
              <div class="gw-obs">
                <div
                  v-for="(observation, index_observation) in observations"
                  :key="index_observation"
                  class="gw-det-fila"
                >
                  <div class="gw-det-fecha">{{ humanizeDate(observation.created_at) }}</div>
                  <div class="gw-det-texto">{{ observation.observation }}</div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Visita domiciliaria" v-if="project.project_type === 0 || project.project_type === 6 || project.project_type === 11">
              <div class="vx-row">
                <div v-for="(visit_concept_item, index_visit_concept) in project.visit_concept" :key="index_visit_concept" class="vx-col w-full lg:w-1/3 mb-base">          
                  <b>{{Object.keys(visit_concept_item)[0]}}: </b> {{visit_concept_item[Object.keys(visit_concept_item)]}}
                </div>
              </div>
            </vs-tab>              
          </div>
        </vs-tabs>
      </template>
    </vx-card>
    <modal-message :modalActive="progressReport" />                  
  </div>
</template>

<script>
import api from '../../mixins/api.js'
import { mapGetters } from 'vuex'
import ModalMessage from './../ModalMessage'
export default {
  mixins: [api],
  props: {
    project: Object
  },
  computed: {
    ...mapGetters(['userInfo']),

    // Las mismas condiciones que deciden cada <vs-tab>, para saber de
    // antemano si va a quedar alguna.
    hayPestanas(){
      var p = this.project || {}
      var obs = p.observations
      var deEquipo = false
      if (obs != null) {
        var listas = Array.isArray(obs)
          ? obs
          : Object.keys(obs).map(function(k){ return obs[k] })
        deEquipo = listas.some(function(lista){
          return lista && lista[0] && this.showObservations(lista[0].type)
        }, this)
      }
      var deVisita = p.project_type === 0 || p.project_type === 6 || p.project_type === 11
      return deEquipo || deVisita
    }
  },
  data (){
    return{
      progressReport: false
    }
  },
  methods: {
    showObservations(type){
      let array = ['Laboral', 'Académico', 'Personal']
      return !array.includes(type)
    },
    humanizeDate(date){
      var arrayDate = date.split("T")
      var stringDate = arrayDate[0]
      var hour = arrayDate[1].split(".")[0]
      return stringDate + ", " + hour
    },
    chunk(array, size) {
      const chunked_arr = [];      
      if(array != null){
        for (let i = 0; i < array.length; i++) {
          const last = chunked_arr[chunked_arr.length - 1];
          if (!last || last.length === size) {
            chunked_arr.push([array[i]]);
          } else {
            last.push(array[i]);
          }
        }
      }
      return chunked_arr;
    },
    async linkToReport(){
      let fileName = this.project.project_person_full_name + " - " + this.project.project_type_name + " - " + this.project.person_id
      console.log(fileName)
      await this.linkReport(this.project.id,this.userInfo.user.id,fileName)
    },
    async linkToResumen(){
      let fileName = this.project.project_person_full_name + " - " + this.project.project_type_name + " - " + this.project.person_id
      console.log(this.userInfo)
      await this.linkResumen(this.project.id,this.userInfo.user.id,fileName)
    }
},
  created(){

  },
  mounted(){

  },
  components:{
    ModalMessage
  }
}
</script>

<style scoped>
.gw-obs{
  max-width: 110ch;
}
</style>